import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  API_SERVICE_CONFIG,
  IApiServiceConfig,
} from '@fullyops/data/base/configuration/api-service-config';
import { Observable } from 'rxjs';
import { MiniContact } from './mini-contact';
import { Contact, ContactInput } from './contact';

@Injectable({ providedIn: 'root' })
export class ApiContactsAdapterService {
  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  getById(id: string): Observable<Contact> {
    return this.http.get<Contact>(this.config.url + 'contacts/' + id);
  }

  getMini(): Observable<MiniContact[]> {
    return this.http.get<MiniContact[]>(this.config.url + 'contacts/names');
  }

  create(input: ContactInput): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(this.config.url + 'contacts', input);
  }

  update(id: string, input: ContactInput): Observable<void> {
    return this.http.patch<void>(this.config.url + 'contacts/' + id, input);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(this.config.url + 'contacts/' + id);
  }
}
